export default __webpack_public_path__ + "static/media/misc-closetC-480w.94c15b8f.png";